import axios from "axios";
import { Notify, Loading } from "notiflix";
import { APIURL } from "./config";

export const generatePresignedURL = (params, cb) => async dispatch => {
   const config = {
      headers: {
         'ContentType': 'application/json',
      },
      data: {}
   };
   const queryString = typeof (params) === 'object' ? Object.keys(params).map(key => `${key}=${params[key]}`).join('&') : '';
   try {
      Loading.standard();
      const res = await axios.get(`${APIURL}/upload/get-presigned-url?${queryString}`, config);
      Loading.remove();
      if (res?.status === 200) {
         if (cb) cb(res?.data?.url);
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      console.log("err >>", err);
   }
}

export const cloudFileUpload = ({ url, file }, cb) => async dispatch => {

   var headers = new Headers();
   headers.append("Content-Type", "image/png");

   var options = {
      method: "PUT",
      body: file,
      redirect: "follow",
      headers,
   };
   Loading.standard();
   fetch(`${url}`, options)
      .then((response) => response)
      .then((result) => {
         Loading.remove();
         if (cb) cb(result?.url?.split("?")?.[0]);
      })
      .catch((error) => {
         Loading.remove();
         console.log("error", error)
      });
}